export default __webpack_public_path__ + "static/media/bikiran-add-2.f56ccfb5.png";